import { render, staticRenderFns } from "./tz-table.vue?vue&type=template&id=c9d4110e&scoped=true&"
import script from "./tz-table.vue?vue&type=script&lang=js&"
export * from "./tz-table.vue?vue&type=script&lang=js&"
import style0 from "./tz-table.vue?vue&type=style&index=0&id=c9d4110e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d4110e",
  null
  
)

export default component.exports